import React from 'react';

function RegistroItem({ registro }) {
  return (
    <tr>
      <td data-title="CUIT">{registro.cuit}</td>
      <td data-title="Apellido y Nombre o Razón Social">{registro.descripcion}</td>
      <td data-title="Empadronamiento REAR/RECE/RCEL">{registro.leyenda}</td>
      <td data-title="Fecha de Empadronamiento">{registro.fechaEmpadronado}</td>
      <td data-title="Período de inicio autorizado">{registro.periodo}</td>
    </tr>
  );
}

export default RegistroItem;
